"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.ChatMessageAttachmentServiceErrorName = "ChatMessageAttachmentServiceError";
class ChatMessageAttachmentServiceError extends CommonBaseError_1.CommonBaseError {
}
exports.ChatMessageAttachmentServiceError = ChatMessageAttachmentServiceError;
//# sourceMappingURL=IChatMessageAttachmentService.js.map